
import { css } from 'lit';
export default css`
.pager{
    display: flex;
    flex-direction: row;
}
  .pager__item--button.pager__item--first{
    margin-right: 1.5rem;
}
  .pager__item--button.pager__item--last{
    margin-left: 1.5rem;
}
  .pager__item--ellipsis{
    font-family: Lato, sans-serif;
}
  .pager__item--ellipsis{
    font-size: 1.25rem;
}
  .pager__item--ellipsis{
    font-weight: 700;
}
  .pager__item--ellipsis{
    line-height: 1.5;
}
`;